import React from "react";
import ReactDOM from "react-dom";
import { Router, Route, browserHistory, IndexRedirect } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import { Provider } from "react-redux";

import configureStore from "./configureStore";
import App from "component/App";
import Tech from "component/Tech";
import Life from "component/Life";
import Job from "component/Job";
import CurrentOpeningsContainer from "component/CurrentOpenings";

// Inject global CSS rules
import grid from "component/Grid.css"; // eslint-disable-line

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

const routes = (
  <Route path="/" component={App}>
    <Route path="tech" component={Tech} />
    <Route path="jobs" component={Life} />
    <Route path="openings" component={CurrentOpeningsContainer} />
    <Route path="job" component={Job} />
    <IndexRedirect to="/life" />
  </Route>
);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} onUpdate={() => window.scrollTo(0, 0)}>
      {routes}
    </Router>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./jobs.js